import {
  TextInput as ReactNativeTextInput,
  View,
  TextInputProps,
  ViewStyle,
  Image,
  ImageStyle,
  TextStyle,
  StyleSheet,
} from 'react-native';
import React from 'react';
import {spacing, corner_radius} from 'theme/Units';
import colors from 'theme/Colors';

type sizeTypes = 'lg' | 'md' | 'sm';

type propType = Readonly<{
  placeholder?: string;
  size?: sizeTypes;
  leftIcon?: JSX.Element;
}> &
  TextInputProps;

export function SearchInput(props: propType): JSX.Element {
  const {
    placeholder,
    size = 'md',
    leftIcon = null,
    ...rest
  } = props;

  const left_icon = leftIcon || (
    <Image
      resizeMode="contain"
      style={styles.icon}
      source={require('assets/icons/search.png')}
    />
  );

  return (
    <View style={[styles.inputWrapper, sizeStyles[size]]}>
      {left_icon}

      <ReactNativeTextInput
        placeholderTextColor={colors.palette.nuetral4}
        style={styles.inputField}
        placeholder={placeholder}
        {...rest}
      />
    </View>
  );
}

type styleTypes = {
  inputWrapper: ViewStyle;
  inputField: TextStyle;
  icon: ImageStyle;
};
const styles: styleTypes = StyleSheet.create({
  icon: {
    width: 16,
    height: 14,
  },
  inputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing['2'],
    borderRadius: corner_radius.rounded,
    backgroundColor: colors.palette.white,
    borderWidth: 1,
    gap: spacing['2'],
    borderColor: colors.palette.stroke,
    width: '100%',
  },
  inputField: {
    flex: 1,
    fontWeight: '500',
    color: colors.palette.black,
    backgroundColor: 'transparent',
  },
});

const sizeStyles: Record<sizeTypes, object> = {
  lg: {height: 48, fontSize: 18},
  md: {height: 40, fontSize: 14},
  sm: {height: 32, fontSize: 14},
};
